export const getValidPathname = (referrer: string, origin: string): string => {
  if (!referrer) {
    return '';
  }

  try {
    const referrerUrl = new URL(referrer);

    const isSameOrigin = referrerUrl.origin === origin;
    if (!isSameOrigin) {
      return '';
    }

    return referrerUrl.pathname;
  } catch (error) {
    return '';
  }
};

export const validateReferrer = (referrer: string, origin: string): boolean => {
  const pathname = getValidPathname(referrer, origin);
  if (!pathname) return false;

  const ALLOWED_PATH_NAMES = [
    /^\/[a-z]{2}-[a-z]{2}\/home/g,
    /^\/[a-z]{2}-[a-z]{2}\/explore/g,
    /^\/[a-z]{2}-[a-z]{2}\/all-courses.html/g,
    /^\/[a-z]{2}-[a-z]{2}\/personal-courses.html/g,
    /^\/[a-z]{2}-[a-z]{2}\/online-courses-overview.html/g,
  ];

  return ALLOWED_PATH_NAMES.some((path) => path.test(pathname));
};

export const validateSsoReferrer = (referrer: string, origin: string): boolean => {
  if (!referrer) return false;

  const referrerUrl = new URL(referrer);

  const isSameOrigin = referrerUrl.origin === origin;

  return (
    !isSameOrigin ||
    referrerUrl.pathname === '/client/sso_login.html' ||
    referrerUrl.pathname.includes('course/')
  );
};
